import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../services/pocketbase';
import AdminBookings from '../components/AdminBookings';
import AdminUsers from '../components/AdminUsers';
import AdminServices from '../components/AdminServices';
import AdminGallery from '../components/AdminGallery';
import AdminContact from '../components/AdminContact';
import AdminHours from '../components/AdminHours';
import AdminAnnouncements from '../components/AdminAnnouncements';
import { FiHome, FiCalendar, FiLogOut, FiUsers, FiPackage, FiImage, FiMenu, FiX, FiInfo, FiClock, FiSpeaker } from 'react-icons/fi';
import './AdminDashboard.css';

function AdminDashboard() {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('bookings');
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const handleLogout = () => {
        logout();
        navigate('/');
        window.location.reload();
    };

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        setIsSidebarOpen(false); // Close sidebar on mobile when tab is clicked
    };

    const renderContent = () => {
        switch (activeTab) {
            case 'bookings':
                return <AdminBookings />;
            case 'users':
                return <AdminUsers />;
            case 'services':
                return <AdminServices />;
            case 'gallery':
                return <AdminGallery />;
            case 'hours':
                return <AdminHours />;
            case 'contact':
                return <AdminContact />;
            case 'announcements':
                return <AdminAnnouncements />;
            default:
                return <AdminBookings />;
        }
    };

    return (
        <div className="admin-dashboard">
            {/* Mobile Header */}
            <header className="admin-mobile-header">
                <button className="menu-toggle" onClick={toggleSidebar}>
                    <FiMenu />
                </button>
                <h2>Admin Panel</h2>
            </header>

            {/* Overlay for mobile */}
            {isSidebarOpen && (
                <div className="sidebar-overlay" onClick={() => setIsSidebarOpen(false)}></div>
            )}

            {/* Sidebar Admin */}
            <aside className={`admin-sidebar ${isSidebarOpen ? 'open' : ''}`}>
                <div className="admin-sidebar-header">
                    <div className="header-content">
                        <h2>Admin Panel</h2>
                        <p>Studio Ambre</p>
                    </div>
                    <button className="close-sidebar" onClick={() => setIsSidebarOpen(false)}>
                        <FiX />
                    </button>
                </div>

                <nav className="admin-nav">
                    <button
                        className={`admin-nav-item ${activeTab === 'bookings' ? 'active' : ''}`}
                        onClick={() => handleTabClick('bookings')}
                    >
                        <FiCalendar /> <span>Réservations</span>
                    </button>

                    <button
                        className={`admin-nav-item ${activeTab === 'services' ? 'active' : ''}`}
                        onClick={() => handleTabClick('services')}
                    >
                        <FiPackage /> <span>Services</span>
                    </button>

                    <button
                        className={`admin-nav-item ${activeTab === 'gallery' ? 'active' : ''}`}
                        onClick={() => handleTabClick('gallery')}
                    >
                        <FiImage /> <span>Galerie</span>
                    </button>

                    <button
                        className={`admin-nav-item ${activeTab === 'hours' ? 'active' : ''}`}
                        onClick={() => handleTabClick('hours')}
                    >
                        <FiClock /> <span>Horaires</span>
                    </button>

                    <button
                        className={`admin-nav-item ${activeTab === 'contact' ? 'active' : ''}`}
                        onClick={() => handleTabClick('contact')}
                    >
                        <FiInfo /> <span>Infos & Contact</span>
                    </button>

                    <button
                        className={`admin-nav-item ${activeTab === 'announcements' ? 'active' : ''}`}
                        onClick={() => handleTabClick('announcements')}
                    >
                        <FiSpeaker /> <span>Annonces</span>
                    </button>

                    <button
                        className={`admin-nav-item ${activeTab === 'users' ? 'active' : ''}`}
                        onClick={() => handleTabClick('users')}
                    >
                        <FiUsers /> <span>Utilisateurs</span>
                    </button>

                    <div className="admin-nav-separator"></div>

                    <button onClick={() => navigate('/')} className="admin-nav-item">
                        <FiHome /> <span>Retour au site</span>
                    </button>

                    <button onClick={handleLogout} className="admin-nav-item logout">
                        <FiLogOut /> <span>Déconnexion</span>
                    </button>
                </nav>
            </aside>

            {/* Contenu principal */}
            <main className="admin-content">
                {renderContent()}
            </main>
        </div>
    );
}

export default AdminDashboard;
